import { ExploreBenefits } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import type { MEMBERSHIP_MODELS } from '@r-and-a-shared-ui/common-kontent-client';
export default {
    component: () => ExploreBenefits,
    mapEntryToProps: (entry: MEMBERSHIP_MODELS.ExploreBenefits) =>
        kontentAiDataMapping.explore_benefits(entry),
};
